import { TValueOfStringRecord } from '@interfaces/common/genericWithModifying';

export const EStatus = {
	active: 'active',
	blocked: 'blocked',
} as const;

export type TStatus = TValueOfStringRecord<typeof EStatus>

export interface IStatusTagProps {
	status: TStatus;
}
